import React, { Component } from 'react'
import FormAppraisals from './components/AppraisalForm/AppraisalForm.container'
import News from '../PageHome/components/Noticias'
import Brokers from '../../components/Brokers'
import SliderResponsive from '../PageCompany/Components/Clients/sliderResponsive'
import { translate } from "react-translate"
import { DIST_URL } from '../../constants/api';
import { Col } from 'react-bootstrap'
import ContactForm from '../commons/ContactForm/ContactForm.component'
import { MainBanner } from '../commons/MainBanner/MainBanner.component'


@translate("Appraisals")
export default class Appraisals extends Component {

  componentWillMount() {
    window.scrollTo(0, 0)
    this.props.setPhone()
    this.props.loadServices()
    this.props.loadClients()
    this.props.loadNewsBySector()
    this.props.loadDirectors()
    this.props.loadBrokers()
  }

  render () {

    const { news, directors, brokers, services, clients, t } = this.props;

    return (
    	<div className="container-fluid">
        <MainBanner
          backgroundURL={'/assets/images/tasaciones-search.jpg'}
          mainTitle={t('Division_Tasaciones')}
          secondaryTitle={t('Appraisals_Quote')}
        >
        </MainBanner>
        <div className="services-container">
          <h2>{t("Nuestros_servicios")} </h2>
          <div className="services-list-box">
            <ul>
              { services.map((item,index) =>
                <Col md={6} sm={12} key={index}>
                  <li>{item.name}</li>
                </Col>
              )}
            </ul>
          </div>
        </div>
        <div className="img-iso-container">
        </div>
        <div className="form-appraisal">
          <h2 className="hidden-xs">{t("Texto_Form")} </h2>
          <h2 className="text-center visible-xs"> {t("Texto_Form_2")} </h2>
          <FormAppraisals />
        </div>

        <div className="form-container visible-xs" id="contact-form" name="contact-form">
          <ContactForm />
        </div>

        {/* { ((directors || []).concat(brokers || []).length > 0) ? (
          <div className="director-container">
            <Brokers brokers={(directors || []).concat(brokers || [])} section={'Tasaciones'}  />
          </div>
        ) : '' } */}

        <div className="clients-container">
          <h2>{t("Clientes_Texto")} </h2>
          <div className="container-logos hidden-xs">
            {clients.map((item, index) =>
              <div className="column-client" key={index}>
                <img src={item.image} alt={item.title}/>
              </div>
            )}
          </div>
          <div className="container-logos visible-xs">
            <SliderResponsive items={clients} />
          </div>
        </div>
        {(news.length > 0) ?
          <News news={news} />
        : '' }
    	</div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/features/PageAppraisals/PageAppraisals.component.js